import { component } from 'flightjs';

function Login() {
    this._showLogin = function(evt, evtData) {
        let destination =
            evtData && evtData.destination
                ? evtData.destination
                : encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search);
        let url = '/login?ReturnUrl=' + destination;
        document.location.href = url;
    };

    this.after('initialize', function() {
        this.on(document, 'ui:login:show', this._showLogin);
    });
}

export default component(Login);
